module.exports = __webpack_public_path__ + "static/media/plan-507+508-desktop-en.98883d95.png";